import { memo, useState } from "react";

import { Brush } from "@material-ui/icons";
import { Popover } from "antd";
import { useChartsContext } from "contexts/ChartContext";

import { useChartEntities } from "hooks/charts";

import ToolbarButton from "../../../base/ToolbarButton";
import SeriesStylesOptions from "./SeriesStylesOptions";

const SeriesStylesToggle = () => {
  const { id } = useChartsContext();
  const [visible, setVisible] = useState(false);

  const {
    pointSize,
    pointOpacity,
    lineSize,
    lineOpacity,
    highlightedLineSize,
    highlightedLineOpacity,
    useSeriesStyleOverride
  } = useChartEntities(id);

  // Show toggle if any series style settings are available
  const hasPointSettings = pointSize?.show && pointOpacity?.show;
  const hasLineSettings = lineSize?.show && lineOpacity?.show;
  const hasHighlightedLineSettings =
    highlightedLineSize?.show && highlightedLineOpacity?.show;

  const isEnabled =
    useSeriesStyleOverride?.enabled &&
    (hasPointSettings || hasLineSettings || hasHighlightedLineSettings);

  return (
    <Popover
      arrowPointAtCenter
      content={<SeriesStylesOptions />}
      placement="bottomRight"
      trigger="click"
      open={visible}
      onOpenChange={(v) => setVisible(v)}>
      <ToolbarButton
        active={useSeriesStyleOverride?.active ?? false}
        key={"SeriesStylesToggle"}
        data-testid="series-styles-toggle"
        disabled={!isEnabled}
        icon={<Brush fontSize="large" />}
        overflowLabel="Series Styles"
        tooltipText="Series Styles"
      />
    </Popover>
  );
};

export default memo(SeriesStylesToggle);
